// // utils/errorHandler.js
// import { toast } from "react-toastify";

// export const handleApiError = (
//   error,
//   fallbackMessage = "Something went wrong!"
// ) => {
//   console.log(error);
//   if (error.response) {
//     // Backend ne response bheja (status code 4xx / 5xx)
//     toast.error(error.response.data.error || fallbackMessage);
//   } else if (error.request) {
//     // Request gaya but koi response nahi aaya
//     toast.error("No response from server. Please try again later.");
//   } else {
//     // Koi aur error (frontend side)
//     toast.error(error.message || fallbackMessage);
//   }
// };

import { toast } from "react-toastify";

export const handleApiError = (
  error,
  fallbackMessage = "Something went wrong!"
) => {
  if (error.response && error.response.data) {
    // Agar backend se `error` ya `message` aayi hai
    const backendMessage =
      error.response.data.error || error.response.data.message;
    toast.error(backendMessage || fallbackMessage);
  } else if (error.request) {
    // Server ne response hi nahi bheja
    toast.error("No response from server. Please try again.");
  } else {
    // Request send hi nahi ho paayi
    toast.error(fallbackMessage);
  }
};
